module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-search"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-dark"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('message.title.main.search')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "id": "fb-search-query",
      "type": "text",
      "placeholder": _vm.$t('message.form.placeholder.query')
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query.length < _vm.minLength),
      expression: "query.length < minLength"
    }],
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.text.no_search_results')) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query.length >= _vm.minLength),
      expression: "query.length >= minLength"
    }],
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.text.displaying_search_results', {
        count: _vm.results.length,
        query: _vm.query
      }))
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searching),
      expression: "searching"
    }]
  }, [_c('loading-spinner')], 1), _vm._v(" "), _vm._l((_vm.results), function(foobar) {
    return _c('div', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.$router.push({
            name: 'Foobar',
            params: {
              id: foobar.id
            }
          })
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(foobar.title))])]), _vm._v(" "), _c('div', {
      staticClass: "search-result description",
      domProps: {
        "innerHTML": _vm._s(foobar.description)
      }
    })])
  })], 2)]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18a195b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foobar/FoobarSearch.vue
// module id = 1823
// module chunks = 1